// import React, { useState } from "react";
// import PropTypes from "prop-types";
// import { toast } from "react-toastify";
// import { Button, Col, Form, Row } from "react-bootstrap";
// import classNames from "classnames";
// import { FormProvider, useForm } from "react-hook-form";
// import * as yup from "yup";
// import { yupResolver } from "@hookform/resolvers/yup";
// import { ResetPasswordAPI } from "api";
// import { customSettings } from "utils/customConfig";
// import { useAppContext } from "Main";

// const schema = yup
//   .object({
//     currentPassword: yup.string().required("This field is required."),
//     newPassword: yup.string().required("This field is required."),
//     confirmPassword: yup
//       .string()
//       .required("This field is required.")
//       .oneOf([yup.ref("newPassword"), null], "Passwords must match"),
//   })
//   .required();

// const PasswordResetForm = ({ hasLabel }) => {
//   const [loading, setLoading] = useState(false);
//   const userFound = localStorage.getItem("user");
//   const { logout } = useAppContext();

//   const submittedValues = {};
//   const methods = useForm({
//     resolver: yupResolver(schema),
//     defaultValues: {},
//   });
//   const {
//     handleSubmit,
//     reset,
//     register,
//     formState: { errors },
//   } = methods;

//   // const onSubmit = async (data) => {
//   //   // e.preventDefault();
//   //   const myData = { ...data, loginId: JSON.parse(userFound)?.loginId };
//   //   // console.log(myData);
//   //   try {
//   //     setLoading(true);
//   //     const response = await ResetPasswordAPI.post(myData);
//   //     setLoading(false);
//   //     // logout();
//   //     toast.success("Password Updated Successfully", {
//   //       position: customSettings.toastPosition,
//   //       autoClose: customSettings.toastClose,
//   //     });
//   //     // ------- Get all object keys form data and set empty values to reset ------------
//   //     const keys = Object.keys(data);
//   //     for (const key of keys) {
//   //       submittedValues[key] = "";
//   //     }
//   //     reset({ ...submittedValues });
//   //   } catch (error) {
//   //     toast.error("Something Went Wrong", {
//   //       position: customSettings.toastPosition,
//   //       autoClose: customSettings.toastClose,
//   //     });
//   //     console.log(error);
//   //   }
//   // };

//   const onSubmit = async (data) => {
//     const myData = { ...data, loginId: JSON.parse(userFound)?.loginId };

//     try {
//       setLoading(true);

//       const response = await ResetPasswordAPI.post(myData);
//       console.log(response);

//       // ✅ Only continue if response is actually successful
//       if (
//         response?.status === 200 &&
//         response?.data?.statusCode === 200 &&
//         response?.data?.data === true
//       ) {
//         toast.success("Password Updated Successfully", {
//           position: customSettings.toastPosition,
//           autoClose: customSettings.toastClose,
//         });

//         // Reset form fields
//         const emptyValues = {};
//         for (const key of Object.keys(data)) {
//           emptyValues[key] = "";
//         }
//         reset(emptyValues);

//         // Logout only on success
//         logout();
//       } else {
//         throw new Error("Password update failed");
//       }
//     } catch (error) {
//       toast.error("Something Went Wrong", {
//         position: customSettings.toastPosition,
//         autoClose: customSettings.toastClose,
//       });
//       console.error(error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Form
//       className={classNames("mt-3", { "text-left": hasLabel })}
//       onSubmit={handleSubmit(onSubmit)}
//     >
//       <Form.Group className="mb-3">
//         {hasLabel && <Form.Label>Current Password</Form.Label>}
//         <Form.Control
//           placeholder={!hasLabel ? "Current Password" : ""}
//           type="password"
//           autoFocus
//           isInvalid={!!errors.currentPassword}
//           {...register("currentPassword")}
//         />
//         <Form.Control.Feedback type="invalid" className="d-flex">
//           {errors.currentPassword?.message}
//         </Form.Control.Feedback>
//       </Form.Group>
//       <Form.Group className="mb-3">
//         {hasLabel && <Form.Label>New Password</Form.Label>}
//         <Form.Control
//           placeholder={!hasLabel ? "New Password" : ""}
//           type="password"
//           isInvalid={!!errors.newPassword}
//           {...register("newPassword")}
//         />
//         <Form.Control.Feedback type="invalid" className="d-flex">
//           {errors.newPassword?.message}
//         </Form.Control.Feedback>
//       </Form.Group>

//       <Form.Group className="mb-3">
//         {hasLabel && <Form.Label>Confirm Password</Form.Label>}
//         <Form.Control
//           placeholder={!hasLabel ? "Confirm Password" : ""}
//           type="password"
//           isInvalid={!!errors.confirmPassword}
//           {...register("confirmPassword")}
//         />
//         <Form.Control.Feedback type="invalid" className="d-flex">
//           {errors.confirmPassword?.message}
//         </Form.Control.Feedback>
//       </Form.Group>

//       <Button
//         type="submit"
//         className="w-100"
//         // onClick={handleSubmit}
//         // disabled={!formData.password || !formData.confirmPassword}
//       >
//         Submit
//       </Button>
//     </Form>
//   );
// };

// PasswordResetForm.propTypes = {
//   hasLabel: PropTypes.bool,
// };

// export default PasswordResetForm;

import React, { useState } from "react";
import PropTypes from "prop-types";
import { toast } from "react-toastify";
import { Button, Form } from "react-bootstrap";
import classNames from "classnames";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { ResetPasswordAPI } from "api";
import { customSettings } from "utils/customConfig";
import { useAppContext } from "Main";
import { FaEye, FaEyeSlash } from "react-icons/fa";

// ✅ Strong password policy regex
const passwordRules = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;

const schema = yup.object({
  currentPassword: yup.string().required("This field is required."),
  newPassword: yup
    .string()
    .required("This field is required.")
    .matches(
      passwordRules,
      "Password must be at least 8 characters, include 1 uppercase, 1 lowercase, 1 number, and 1 special character."
    ),
  confirmPassword: yup
    .string()
    .required("This field is required.")
    .oneOf([yup.ref("newPassword")], "Passwords must match"),
});

const PasswordResetForm = ({ hasLabel }) => {
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState({
    current: false,
    new: false,
    confirm: false,
  });

  const userFound = localStorage.getItem("user");
  const { logout } = useAppContext();

  const methods = useForm({
    resolver: yupResolver(schema),
  });

  const {
    handleSubmit,
    reset,
    register,
    formState: { errors },
  } = methods;

  const toggleVisibility = (field) => {
    setShowPassword((prev) => ({ ...prev, [field]: !prev[field] }));
  };

  const onSubmit = async (data) => {
    const myData = { ...data, loginId: JSON.parse(userFound)?.loginId };

    try {
      setLoading(true);
      const response = await ResetPasswordAPI.post(myData);

      if (
        response?.status === 200 &&
        response?.data?.statusCode === 200 &&
        response?.data?.data === true
      ) {
        toast.success("Password Updated Successfully", {
          position: customSettings.toastPosition,
          autoClose: customSettings.toastClose,
        });

        reset({
          currentPassword: "",
          newPassword: "",
          confirmPassword: "",
        });

        logout();
      } else {
        throw new Error("Password update failed");
      }
    } catch (error) {
      toast.error("Something Went Wrong", {
        position: customSettings.toastPosition,
        autoClose: customSettings.toastClose,
      });
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const renderPasswordField = (label, name, typeKey) => (
    <Form.Group className="mb-3">
      {hasLabel && <Form.Label>{label}</Form.Label>}
      <div className="position-relative">
        <Form.Control
          placeholder={!hasLabel ? label : ""}
          type={showPassword[typeKey] ? "text" : "password"}
          isInvalid={!!errors[name]}
          {...register(name)}
          style={{ paddingRight: errors[name] ? "10px" : "5px" }}
          // className={errors[name] ? "pe-5" : ""} // Add right padding when there's an error
        />
        <span
          role="button"
          style={{
            position: "absolute",
            // top: errors[name] ? "28%" : "40%", // Adjust position based on error
            right: errors[name] ? "32px" : "12px",
            transform: "translateY(-50%)",
            paddingBottom: "38px",
            zIndex: 2,
            cursor: "pointer",
            color: "#6c757d",
          }}
          onClick={() => toggleVisibility(typeKey)}
        >
          {showPassword[typeKey] ? <FaEyeSlash /> : <FaEye />}
        </span>
        <Form.Control.Feedback type="invalid" className="d-flex">
          {errors[name]?.message}
        </Form.Control.Feedback>
      </div>
    </Form.Group>
  );

  return (
    <Form
      className={classNames("mt-3", { "text-left": hasLabel })}
      onSubmit={handleSubmit(onSubmit)}
    >
      {renderPasswordField("Current Password", "currentPassword", "current")}
      {renderPasswordField("New Password", "newPassword", "new")}
      {renderPasswordField("Confirm Password", "confirmPassword", "confirm")}

      <Button type="submit" className="w-100" disabled={loading}>
        {loading ? "Submitting..." : "Submit"}
      </Button>
    </Form>
  );
};

PasswordResetForm.propTypes = {
  hasLabel: PropTypes.bool,
};

export default PasswordResetForm;
